<template>
   <div class="modal" v-show="show">
    <div class="modal-wrapper">
      <div :class="[`modal-container ${color}`, {'full': activeFullWidth}]">
        <div class="modal-header" slot="modal-header" v-if="title != ''">
            <div class="circle" v-if="icon != ''">
                <feather :type="icon"></feather>
            </div>
            {{ title }}
        </div>
        <slot name="modal-header"></slot>  
        <div class="modal-body">
            <slot name="modal-body"></slot>    
        </div>
        <slot name="modal-footer"></slot>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal-Basic',
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: true},
    color: { type: String, default: "success"},
    fullWidth: { type: Boolean, default: false },
    icon: { type: String, default: ""}
  },
  data() {
    return {
      active: false,
      activeFullWidth: this.fullWidth
    }
  },
  watch: {
    fullWidth(val){
      this.activeFullWidth = val
    }
  }
}
</script>